import { useQuery } from 'react-query'

// Libs
import { fetchPromotionPriceRange, IPromotionPriceRangeParams } from '@/api/fetchPromotionPriceRange'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

export const usePromotionPriceRange = ({ couponCodes, skuList }: IPromotionPriceRangeParams) => {
  const {
    data,
    isFetched: isPromotionPriceRangeFetched,
    isSuccess: isPromotionPriceRangeSuccess,
  } = useQuery([QUERY_KEY.FETCH_PROMOTION_PRICE_RANGE, { couponCodes, skuList }], () => fetchPromotionPriceRange({ couponCodes, skuList }), {
    enabled: couponCodes.length > 0 && skuList.length > 0,
  })
  return {
    promotionPriceRangeData: data,
    isPromotionPriceRangeFetched,
    isPromotionPriceRangeSuccess,
  }
}
